import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const ProposalOperationsDashboardPage = createLazyPage(
  () =>
    import(
      '@app/modules/ict/pages/ProposalsOperations/ProposalOperationsDashboardPage'
    )
);

const ProposalOperationDetailsPage = createLazyPage(
  () =>
    import(
      '@app/modules/ict/pages/ProposalsOperations/ProposalOperationDetailsPage'
    )
);

const ProposalPoliciesPage = createLazyPage(
  () =>
    import('@app/modules/ict/pages/ProposalsOperations/ProposalPoliciesPage')
);

const SchedulerAdminPage = createLazyPage(
  () => import('@app/modules/ict/pages/SchedulerAdmin/SchedulerAdminPage')
);

const LogsExplorerPage = createLazyPage(
  () => import('@app/modules/ict/pages/LogsExplorer/LogsExplorerPage')
);

const ConectaCronJobPage = createLazyPage(
  () => import('@app/modules/ict/pages/ConectaCronJob/ConectaCronJobPage')
);

export const ictRoutes: AppRouteDefinition[] = [
  {
    key: 'conecta-cronjob',
    path: 'conecta/cronjob',
    element: <ConectaCronJobPage />,
  },
  {
    key: 'logs',
    path: 'logs',
    element: <LogsExplorerPage />,
  },
  {
    key: 'scheduler-admin',
    path: 'scheduler-admin',
    element: <SchedulerAdminPage />,
  },
  {
    key: 'propostas-operacional',
    path: 'propostas-operacional',
    element: <ProposalOperationsDashboardPage />,
  },
  {
    key: 'propostas-operacional-detalhe',
    path: 'propostas-operacional/:processId',
    element: <ProposalOperationDetailsPage />,
  },
  {
    key: 'propostas-politicas',
    path: 'propostas-politicas',
    element: <ProposalPoliciesPage />,
  },
];
